<template>
  <div>
    <div v-if="dialogVisible" class="sentryModel">
      <div class="el-dialog el-dialog--center real-dialog" style="width: 450px;">
        <div class="el-dialog__header">
          <span class="el-dialog__title">选择岗亭</span>
        </div>
        <div class="el-dialog__body">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
            <el-form-item label="岗亭列表" prop="sentryValue" v-if="resObj.state === 'success'">
              <el-select v-model="ruleForm.sentryValue" placeholder="请选择岗亭">
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else label-width="0px" style="text-align: center;">
              <div>{{resObj.message}}</div>
            </el-form-item>
            <el-form-item label-width="0">
              <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "loginSelect",
  props:{},
  data: () => ({
    dialogVisible: false,
    options: [],
    ruleForm: {
      sentryValue: undefined
    },
    rules: {
      sentryValue: [
        {required: true, message: '请选择岗亭', trigger: 'change'}
      ],
    },
    resObj: {
      state: 'success',
      message: ''
    }
  }),
  mounted() {
    // this.getSentryData()
  },
  methods: {
    submitForm(formName) {
      if (this.resObj.state === 'failed') {
        this.$store.dispatch("LogOut");
        this.$router.push("/login");
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$emit("selectChange", this.ruleForm.sentryValue);
            this.dialogVisible = false
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
  }
};
</script>

<style lang="scss">
  .sentryModel{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.6);
    z-index: 110;
    display: flex;
    justify-content: center;
    align-items: center;
    & .el-dialog__body{
      text-align: center;
    }
  }
</style>
